import type { XdpDataQuery_XdpV1Resource_slug_elements_xdpMetadata_XdpV1_cdpMetadataMember_cdpMetadata_courseTypeMetadata as CdpCourseTypeMetadata } from 'bundles/accomplishments/components/course-certificates/__generated__/XdpDataQuery';
import { shareUtmProductCourseParam, shareUtmProductProjectParam } from 'bundles/accomplishments/constants';
import { isGuidedProject } from 'bundles/enterprise-legacy-learner-home/utils/courseTypeMetadataUtils';
import type {
  PdpPageQuery_XdpV1Resource_slug_elements_xdpMetadata_XdpV1_cdpMetadataMember_cdpMetadata_courseTypeMetadata_XdpV1_rhymeProjectMember as RhymeProjectMetadata,
  PdpPageQuery_XdpV1Resource_slug_elements_xdpMetadata_XdpV1_cdpMetadataMember_cdpMetadata_courseTypeMetadata_XdpV1_standardCourseMember as StandCourseMetadata,
} from 'bundles/enterprise-legacy-xdp/components/miniPDP/__generated__/PdpPageQuery';

type CourseTypeMetadata = StandCourseMetadata | RhymeProjectMetadata;

export const getCourseCertProductUtm = (courseTypeMetadata: CdpCourseTypeMetadata | null) => {
  if (isGuidedProject(courseTypeMetadata as CourseTypeMetadata)) {
    return shareUtmProductProjectParam;
  } else {
    return shareUtmProductCourseParam;
  }
};
